import React from "react";
export const ArrowIcon = (props) => {
    var _a;
    const color = (_a = props.color) !== null && _a !== void 0 ? _a : "#091E42";
    return (React.createElement("svg", Object.assign({}, props, { width: props.size, height: props.size, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }),
        React.createElement("path", { d: "M11.625 14.25L6.375 9L11.625 3.75", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })));
};
//# sourceMappingURL=Arrow.js.map